import { render } from "./GrafIrrig.vue?vue&type=template&id=2957096a&scoped=true"
import script from "./GrafIrrig.vue?vue&type=script&lang=js"
export * from "./GrafIrrig.vue?vue&type=script&lang=js"

import "./GrafIrrig.vue?vue&type=style&index=0&id=2957096a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2957096a"]])

export default __exports__